import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../root-saga/root-state';
import { initialState } from '.';

const selectDomain = (state: RootState) => state['login'] || initialState;

export const selectIsLoading = createSelector([selectDomain], (state) => state.loading);
export const selectIsLoggedIn = createSelector([selectDomain], (state) => state.isLoggedIn);
